import { Injectable, OnDestroy } from '@angular/core';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import * as store from '@daas-consulting/production/remitos/frontend/store';
import { RemitosPrintPageViewContract } from '@daas-consulting/production/remitos/frontend/view_contracts';
import { Actions, Select, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';

export { RemitosPrintPageViewContractId } from '@daas-consulting/production/remitos/frontend/view_contracts';

@Injectable()
export class RemitosPrintPageViewModel
  implements RemitosPrintPageViewContract, OnDestroy
{
  @Select(store.print.selectors.RemitosPrintSelectors.printData)
  printData$!: Observable<models.print.PrintDataView | null>;

  readonly printSuccessful$: Observable<void>;

  readonly #store: Store;
  readonly #actions$: Actions;
  readonly #destroy$ = new Subject<void>();
  readonly #printSuccessful$ = new Subject<void>();

  constructor(store: Store, actions$: Actions) {
    this.#store = store;
    this.#actions$ = actions$;
    this.printSuccessful$ = this.#printSuccessful$.asObservable();
    this._connectEvents();
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  loadPrintData(remitoId: string): void {
    this.#store.dispatch(new store.print.actions.GetPrintData(remitoId));
  }

  print(remitoId: string): void {
    this.#store.dispatch(new store.print.actions.Print({ remitoId }));
  }

  private _connectEvents(): void {
    this.#actions$
      .pipe(
        ofActionSuccessful(store.print.actions.PrintSuccessful),
        takeUntil(this.#destroy$)
      )
      .subscribe(() => this.#printSuccessful$.next());
  }
}
